export default "__VITE_ASSET__BaEpooSh__"